module.exports = __webpack_public_path__ + "static/img/编组 5备份 2.7c7e427.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hz/编组 5备份 2.png
// module id = kHpZ
// module chunks = 1